export const isValidCarNum = char =>
    /^[A-Za-z0-9]{4}([DFdf]{1})?[挂学警港澳]{1}$/.test(char) ||
    /^([DFdf]{1})?[A-Za-z0-9]{4}[挂学警港澳]{1}$/.test(char) ||
    /^([DFdf]{1})?[A-Za-z0-9]{5}$/.test(char) ||
    /^[A-Za-z0-9]{5}([DFdf]{1})?$/.test(char)

export const isInvalidPhone = phone => {
    // 电话号码
    const pattern = /^1[3456789]\d{9}$|1[3456789]\d-\d{4}-\d{4}$|1[3456789]\d[ ]\d{4}[ ]\d{4}$/ // 验证国内手机
    return pattern.exec(phone)
}

export const hasChineseChar = char => {
    // 检测输入是否含有中文字符
    const pattern = /[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/gi
    return pattern.exec(char)
}
